<template>
  <li class="sub-menu__item" v-hover="{ cb: hover, args: [BRAND_PRIMARY_DARKEST] }">
    <a :href="href" class="sub-menu__link">
      <slot></slot>
      <Icon v-if="!!icon" class="sub-menu__icon" :name="icon" :size="iconSize" :color="iconColor" />
    </a>
  </li>
</template>

<script>
import { ref } from '@vue/composition-api';
import { Link } from '@inertiajs/inertia-vue';
import Icon from '@/lego/components/icons/Icon.vue';

const BRAND_PRIMARY_DARKEST = '#C88F00';

export default {
  components: {
    Link,
    Icon,
  },
  props: {
    href: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    iconSize: {
      type: Number,
      default: 20,
    },
  },
  setup() {
    var iconColor = ref('black');

    function hover(el, color) {
      iconColor.value = color ?? 'black';
    }

    return {
      iconColor,
      hover,
      BRAND_PRIMARY_DARKEST,
    };
  },
};
</script>

<style lang="postcss" scoped>
.sub-menu {
  &__item {
    @apply flex justify-between gap-xxxs lg:hover:bg-neutral-lightest lg:px-xxs lg:py-xxxs;

    &:first-of-type {
      @apply rounded-t-s;
    }
    &:last-of-type {
      @apply rounded-b-s;
    }
    &:not(:hover) {
      transition: padding-left 0.5s ease;
    }
    &:hover {
      @apply text-brand-primary-darkest lg:bg-brand-primary-lightest lg:pl-md;

      &:before {
        @apply absolute left-xxxs lg:content-['\2192'];
      }
    }
  }
  &__link {
    @apply flex justify-between w-full lg:w-fit;
  }
  &__icon.icon {
    @apply lg:hidden;
  }
}
</style>
